import { render, staticRenderFns } from "./labortypes.vue?vue&type=template&id=08b84990&lang=pug"
import script from "./labortypes.vue?vue&type=script&lang=js"
export * from "./labortypes.vue?vue&type=script&lang=js"
import style0 from "./labortypes.vue?vue&type=style&index=0&id=08b84990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports